
<template>
  <a-modal
    :title="title"
    :width="640"
    :visible="visible"
    :confirmLoading="confirmLoading"
    :maskClosable="false"
    @cancel="handleCancel"
  >
    <a-spin :spinning="confirmLoading">
      <a-form-item
        v-show="false"
        label="id"
        :labelCol="labelCol"
        :wrapperCol="wrapperCol"
      >
        <a-input
          v-decorator="['id']"
          :disabled="editable || showable"
        />
      </a-form-item>
      <a-form :form="form">
         <a-form-item
          label="主键"
          :hidden="true"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input
            :disabled="showable"
            v-decorator="['id', {rules: [{required: false, message: '请输入id'}]}]" />
        </a-form-item>
        <a-form-item
          label="名称"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input
            placeholder="请输入名称"
            :disabled="showable"
            v-decorator="['name', {rules: [{required: true, message: '请输入name'}]}]" />
        </a-form-item>
        <a-form-item
          label="手机"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input
            placeholder="请输入手机号码"
            :disabled="showable"
            v-decorator="['phone', {rules: [{required: true, message: '请输入phone'}]}]" />
        </a-form-item>
         <a-form-item
          label="地址"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input
            placeholder="请输入地址"
            :disabled="showable"
            v-decorator="['address', {rules: [{required: true, message: '请输入address'}]}]" />
        </a-form-item>
<!--         <a-form-item-->
<!--          label="创建时间"-->
<!--          :labelCol="labelCol"-->
<!--          :wrapperCol="wrapperCol"-->
<!--        >-->
<!--          <a-input-->
<!--            :disabled="showable"-->
<!--            v-decorator="['createTime', {rules: [{required: true, message: '请输入createTime'}]}]" />-->
<!--        </a-form-item>-->
<!--         <a-form-item-->
<!--          label="更新时间"-->
<!--          :labelCol="labelCol"-->
<!--          :wrapperCol="wrapperCol"-->
<!--        >-->
<!--          <a-input-->
<!--            :disabled="showable"-->
<!--            v-decorator="['updateTime', {rules: [{required: true, message: '请输入updateTime'}]}]" />-->
<!--        </a-form-item>-->
<!--         <a-form-item-->
<!--          label="创建者ID"-->
<!--          :labelCol="labelCol"-->
<!--          :wrapperCol="wrapperCol"-->
<!--        >-->
<!--          <a-input-->
<!--            :disabled="showable"-->
<!--            v-decorator="['createBy', {rules: [{required: true, message: '请输入createBy'}]}]" />-->
<!--        </a-form-item>-->
<!--         <a-form-item-->
<!--          label="删除标记"-->
<!--          :labelCol="labelCol"-->
<!--          :wrapperCol="wrapperCol"-->
<!--        >-->
<!--          <a-input-->
<!--            :disabled="showable"-->
<!--            v-decorator="['delFlag', {rules: [{required: true, message: '请输入delFlag'}]}]" />-->
<!--        </a-form-item>-->
      </a-form>
    </a-spin>
    <template slot="footer" >
      <div v-show="editable || addable">
        <a-button key="cancel" @click="handleCancel">取消</a-button>
        <a-button key="forward" :loading="confirmLoading" type="primary" @click="handleOk">保存</a-button>
      </div>
    </template>
  </a-modal>
</template>

<script>
import pick from 'lodash.pick'
import { FormMixin } from '@/mixins/FormMixin'
import { getObj, addObj, putObj } from '@/api/common/SxSupplier'

export default {
  name: 'SxSupplierAddOrUpdate',
  mixins: [FormMixin],
  data () {
    return {
      confirmLoading: false,
      form: this.$form.createForm(this)
    }
  },
  methods: {
    edit (id, type) {
      this.visible = true
      const { form: { setFieldsValue, resetFields } } = this
      if (['edit', 'show'].includes(type)) {
        this.confirmLoading = true
        getObj(id).then(res => {
          const record = res.data
          this.confirmLoading = false
          this.$nextTick(() => {
            setFieldsValue(pick(record, ['id', 'name', 'phone', 'address']))
          })
        })
      } else {
        resetFields()
      }
    },
    handleOk () {
      this.form.validateFields(async (err, values) => {
        if (!err) {
          this.confirmLoading = true
          try {
            if (this.type === 'add') {
              await addObj(values)
            } else if (this.type === 'edit') {
              await putObj(values)
            }
            setTimeout(() => {
              this.confirmLoading = false
              this.$emit('ok')
              this.handleCancel()
            }, 1500)
          } catch (e) {
            this.confirmLoading = false
            this.$message.error(e.msg)
          }
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
